import { render, staticRenderFns } from "./GroupFile.vue?vue&type=template&id=9b38d686&scoped=true&"
import script from "./GroupFile.vue?vue&type=script&lang=js&"
export * from "./GroupFile.vue?vue&type=script&lang=js&"
import style0 from "./GroupFile.vue?vue&type=style&index=0&id=9b38d686&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b38d686",
  null
  
)

export default component.exports